/**
 * Installer link for the Connector version this machine is OFFERED (staged-rollout aware).
 * The promoted /download/* links always serve CONNECTOR_LATEST_TAG (the fleet tag), so a
 * canary machine offered 11.0.341 while the fleet is on 11.0.340 must get the versioned
 * mirror link (/downloads/vX/…). Only an explicit 404 from the mirror falls back.
 */
import { logUpdaterDiagnostic, resolveManualDownloadUrl } from './updaterUi';

/** True for the promoted fleet links (/download/mac/arm64 …) that always serve the fleet tag. */
export function isPromotedFleetDownloadUrl(url) {
  return /^https:\/\/api\.maestroaudio\.net\/download(\/|$)/.test(String(url || ''));
}

export async function resolveOfferedDownloadUrl(version, fallbackUrl) {
  const ver = String(version || '').replace(/^v/i, '').trim();
  if (!ver) return fallbackUrl || resolveManualDownloadUrl(null);
  const url = await resolveManualDownloadUrl(ver);
  if (!/\/downloads\/v/.test(url)) return url;
  try {
    const res = await fetch(url, { method: 'HEAD', credentials: 'omit' });
    if (res.status === 404) {
      logUpdaterDiagnostic('versioned-download-missing', `Versioned installer missing for v${ver}`, { url });
      return fallbackUrl || resolveManualDownloadUrl(null);
    }
  } catch {
    /* network hiccup — keep the versioned link */
  }
  return url;
}
